import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core'
import { MatProgressButtonOptions } from '@mmx/shared'

@Component({
  selector: 'mmx-progress-button',
  templateUrl: './progress-button.component.html',
  styleUrls: ['./progress-button.component.scss'],
  standalone: false,
})
export class ProgressButtonComponent implements OnChanges {
  @Input() options: MatProgressButtonOptions
  @Input() active: boolean
  @Input() disabled: boolean
  @Output() btnClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>()

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if (!this.options.disabled && !this.options.active) {
      this.btnClick.emit(event)
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.active) {
      this.options.active = changes.active.currentValue
    }
    if (changes.disabled) {
      this.options.disabled = changes.disabled.currentValue
    }
  }
}
